module.exports = __webpack_public_path__ + "img/wodeerweima.57723ff9.png";